import { Component, Input } from '@angular/core';
import { faTimesCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {

  @Input() alertLevel: string;
  @Input() alertMessage: string;
  @Input() alertDetails: string;

  public showAlert: boolean = true;
  public showDetails: boolean = false;
  public faTimesCircle: IconDefinition = faTimesCircle;

  constructor() { }
}
